// Logo + the screen title (a category name from the DB) over the jasper rule. The
// size labels on the right are the variant names from the DB; they only appear when
// the list actually has more than one price column to head.
export function Header({ title, columns }: { title: string; columns: string[] }) {
  return (
    <div className="flex items-end justify-between pb-[16px] border-b-[6px] border-brand-jasper">
      <div className="flex items-end space-x-[24px]">
        <img src="/logo.svg" alt="Curry Me" className="block h-[64px] w-auto" />
        <div className="font-primary font-bold text-[76px] leading-[0.95] tracking-[-0.01em] text-brand-jasper">
          {title}
        </div>
      </div>
      {columns.length > 1 ? (
        <div className="flex pb-[8px]">
          {columns.map((name) => (
            <div
              key={name}
              className="w-[170px] text-right font-secondary font-bold text-[30px] leading-none tracking-[0.08em] uppercase text-gray-600"
            >
              {name}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  )
}
